import { Component } from 'react';

import { captureError } from '@rover/rsdk/src/modules/ErrorReporting';
import { getCurrentScope } from '@rover/rsdk/src/modules/ErrorReporting/sentry';

export type Props = {
  userOpk?: string;
  children: JSX.Element | JSX.Element[];
};

export type State = {
  hasError: boolean;
};

export default class Sentry extends Component<Props, State> {
  componentDidMount(): void {
    // Use setTimeout to ensure the main CPU thread remains responsive
    setTimeout(() => {
      getCurrentScope().setUser({
        id: this.props.userOpk,
      });
    });
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    captureError(error, { errorInfo });
  }

  render(): React.ReactNode {
    return this.props.children;
  }
}
